/* eslint-disable */
import React from 'react'
import http from '../../Component/Interceptor/Interseptor'
import HeaderTable from '../BaseComponent/HeaderTable'
import $ from 'jquery'
import {accounting} from 'accounting'
import {message} from 'antd'
import {Link} from 'react-router-dom'
import ReactToPrint from 'react-to-print'
import '../../../src/font/iransans.ttf'
import jMoment from 'moment-jalaali'
import REPORT_DISPATCH from '../BaseComponent/REPORTDISPATCH'
import REPORT_RETAIL from '../BaseComponent/REPORTRETAIL'
import USER_MANAGE from '../BaseComponent/USERMANAGE'
import FromToPicker from '../BaseComponent/FromToPicker'
import SearchableCombo from '../BaseComponent/searchableCombo'
import Loader from '../loaders/loader'
import AutoComplete from '../BaseComponent/autocomplete'

class Animale extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      loading: false,
      Providers: [],
      comboProvides: [],
      printInfo: [],
      lengthProviders: 0,
      pageNumber: 1,
      basket: [],
      extraColumns: {},
      arrayExtraColumns: [],
      ids: [],
      providers: [],
      Drivers: [],
      driverText: '',
      providerText: '2093 - پشتیبانی امور دام کشور',
      sumCount: [],
      finalDriverText: '',
      shiftText: '',
      finalShiftText: '',
      data: [],
      fromPrintDate: '',
      toPrintDate: '',
      fromDate: '',
      toDate: '',
      timesInterval: [],
      buttonClicked: false,
      driverId: '',
      aggregation: {},
      providerId: ''
    }
  }

  componentDidMount() {
    sessionStorage.setItem('pageNumber', '1')
    sessionStorage.setItem('dropDownVal', '10')

    $(function() {
      $('.filterBtn').on('click', function() {
        $('.basketFilterComponent').slideToggle()
      })
    })

    http.get(`public/base/type/timeIntervals`, {}).then((response) => {
      if (response.data.error == null) {
        this.setState({
          timesInterval: response.data.object
        })
      }
    })

    // http.get(`${REPORT_RETAIL.REPORT_RETAIL_LIST_PROVIDER}`, {}).then((response) => {

    //     if (response.data.error == null) {

    //         this.setState({
    //             providers: response.data.object
    //         })
    //     }
    //     // alert(JSON.stringify(response.data))
    // }).catch((error) => {
    //     alert(JSON.stringify(error))
    // });

    http
      .get(`${USER_MANAGE.USER_MANAGE_LIST_DRIVER}`, {})
      .then((response) => {
        // alert(JSON.stringify(response.data))
        if (response.data.error == null) {
          var drivers = response.data.object
          for (let i = 0; i < drivers.length; i++) {
            drivers[i]['value'] = drivers[i].personId
            drivers[i]['label'] = drivers[i].personId + ' - ' + drivers[i].name
          }

          this.setState({
            Drivers: response.data.object
          })
        }
      })
      .catch((error) => {
        alert(JSON.stringify(error))
      })
  }

  onResultFetched(data) {
    this.setState({
      baskets: data
    })
  }

  changeDropDown(data) {
    this.setState({
      baskets: data,
      lengthProducts: sessionStorage.getItem('countAll')
    })
  }

  handleChangeFromDate = (fromDate) => {
    this.setState({
      fromDate
    })
  }

  handleChangeToDate = (toDate) => {
    this.setState({
      toDate
    })
  }

  showCount = (id, items) => {
    for (let i = 0; i < items.length; i++) {
      // alert(JSON.stringify(items))
      // alert(items.stockProductId)
      if (id == items[i]['stockProductId']) {
        return items[i]['alternativeQuantity']
      }
    }
    // return 0;
  }

  getCount = () => {
    let data = this.state.basket
    var arr = []
    for (let j = 0; j < this.state.ids.length; j++) {
      arr[j] = 0
    }

    for (let i = 0; i < data.length; i++) {
      for (let k = 0; k < this.state.ids.length; k++) {
        let count = this.showCount(this.state.ids[k], data[i].items)
        if (count == null) {
          count = 0
        }
        arr[k] += count
      }
    }
    this.setState({
      sumCount: arr
    })
  }

  showSumCount = (index) => {
    // alert(this.state.sumCount[index])
    return this.state.sumCount[index]
  }

  showValue = (id, items) => {
    for (let i = 0; i < items.length; i++) {
      if (id == items[i]['stockProductId']) {
        return items[i]['quantity']
      }
    }
    // return 0;
  }

  changeSelectProvider(e) {
    let target = e.target

    this.setState({
      providerText: target.options[target.selectedIndex].text
    })
  }

  changeSelectDriver(e) {
    let target = e.target

    this.setState({
      shiftText: target.options[target.selectedIndex].text
    })
  }

  changeShift(e) {
    let target = e.target

    this.setState({
      driverText: target.options[target.selectedIndex].text
    })
  }

  filter() {
    var providerId = this.state.providerId
    let driverId = this.state.driverId == null || this.state.driverId == '' ? '' : this.state.driverId.personId
    var planTimeType = $('#planTimeType').val()
    var dateMin = this.state.fromDate
    var dateMax = this.state.toDate

    if (providerId == '') {
      message.error('تامین کننده را مشخص کنید')
    } else if (dateMax == '' || dateMin == '') {
      message.error('هر دو تاریخ وارد شود')
    } else if ((dateMin != '' || dateMin == null) && isNaN(dateMin)) {
      message.error('فرمت تاریخ ابتدا صحیح نیست')
    } else if ((dateMax != '' || dateMax == null) && isNaN(dateMax)) {
      message.error('فرمت تاریخ انتها صحیح نیست')
    } else {
      this.setState({
        toPrintDate: this.state.fromDate == '' ? '-' : jMoment(this.state.fromDate).format('jYY/jMM/jDD'),
        fromPrintDate: this.state.toDate == '' ? '-' : jMoment(this.state.toDate).format('jYY/jMM/jDD'),
        loading: true
      })

      http
        .get(
          `${
            REPORT_DISPATCH.REPORT_DISPATCH_DELIVERYPACK_COLUMN
          }?export=true&pageNumber=1&pageSize=10&driverId=${driverId}&providerId=${providerId}&planDateMin=${
            dateMin == '' ? '' : dateMin
          }&planDateMax=${
            dateMax == '' ? '' : dateMax
          }&timeIntervalId=${planTimeType}&sortBy=planDate_Desc,planTimeFrom_Asc,invoiceNum_Asc`,
          {}
        )
        .then((response) => {
          if (response.data.error == null) {
            var arr = []
            $('.showBaseTable,.print').fadeIn()
            let result = response.data.object.result
            for (let i = 0; i < result.length; i++) {
              result[i]['invoiceNum'] = result[i]['invoice'].invoiceNum
              result[i]['buyerName'] = result[i]['invoice'].buyerName
              if (!(result[i]['driver'] == null)) {
                result[i]['driverName'] = result[i]['driver'].name
              }

              if (result[i]['invoice'].paid) {
                result[i]['payment'] = result[i]['invoice'].payableAmount
              } else {
                result[i]['payment'] = '0'
              }
            }

            this.setState({
              basket: response.data.object.result,
              extraColumns: response.data.object.extraColumns,
              finalDriverText: this.state.driverText,
              finalShiftText: this.state.driverId == null || this.state.driverId == '' ? '' : this.state.driverId.name,
              buttonClicked: true,
              loading: false
            })

            Object.keys(this.state.extraColumns).map((key) =>
              arr.push(parseInt(this.state.extraColumns[key]['stockProductId']))
            )
            this.setState({
              ids: arr
            })
            this.getCount()
          } else {
            $('.showBaseTable,.print').fadeOut()
            this.setState({
              loading: false
            })

            // message.error(response.data.description)
          }
        })
        .catch(
          this.setState({
            loading: false
          })
        )
    }
  }

  compareBy(key) {
    return function(a, b) {
      if (a[key] < b[key]) return -1
      if (a[key] > b[key]) return 1
      return 0
    }
  }

  sortBy(key) {
    let arrayCopy = this.state.basket
    arrayCopy.sort(this.compareBy(key))
    this.setState({data: arrayCopy})
  }

  getValueDriver = (driverId) => {
    this.setState({
      driverId
    })
  }

  render() {
    let excelColumns = [
      {title: 'نام خریدار', value: 'buyerName'},
      {title: 'نام تحویل گیرنده', value: 'recipientName'},
      {title: 'ادرس', value: 'address'},
      {title: 'موبایل', value: 'mobile'},
      {title: 'تلفن', value: 'phone'},
      {title: 'شیوه ارسال', value: 'deliveryMethodTitle'}
    ]

    let titf = this.state.extraColumns
    let self = this
    let pageNumber = sessionStorage.getItem('pageNumber')
    let dropDownVal = sessionStorage.getItem('dropDownVal')
    let {loading} = this.state

    var tilfValue = Object.keys(titf).map((key) => (
      <React.Fragment>
        <td colSpan={2}>{titf[key]['productName']}</td>
      </React.Fragment>
    ))

    var tilfValue2 = Object.keys(titf).map((key) => (
      <React.Fragment>
        <td>تعداد</td>
        <td>وزن</td>
      </React.Fragment>
    ))

    var initialVal = 0
    var sumpayable = this.state.basket.reduce(function(acc, current) {
      return Number(acc) + Number(current.totalInfo.payableAmount)
    }, initialVal)

    return (
      <div className="rtl">
        <Loader show={loading} />
        {/*<AdminMenu/>*/}
        <div className="wrapperIframe">
          <ul className="breadcrumb">
            <li>
              <Link to={'/search'}>به روزرسان</Link>
            </li>
            <li>گزارشات</li>
            <li>گزارش ستونی محصولات تامین کننده</li>
          </ul>
          <div className="tableComponent">
            <div className="tableTools">
              <div className="tableOptionWrapp">
                <HeaderTable
                  addUrl=""
                  url={REPORT_DISPATCH.REPORT_DISPATCH_DELIVERYPACK_POLYGONSEARCH_COLUMN}
                  showRow={false}
                  printLink={''}
                  ChangeDropDown={this.changeDropDown.bind(this)}
                  printUrl="printBaskets"
                  printComponent={this.printTable}
                  execelUrl={REPORT_DISPATCH.REPORT_DISPATCH_DELIVERYPACK_POLYGONSEARCH_COLUMN + '?export=true'}
                  excelColumns={excelColumns}
                  titleAdd="افزودن شهر"
                />
                <button className="filterBtn">
                  <i className="fa fa-search" />
                </button>
                <ReactToPrint
                  copyStyles={false}
                  pageStyle='


body {
  counter-reset: section;
}

h3::before {
  counter-increment: section;
  content: counter(section);
}



@page{
size:A4 portrait;
counter-increment: page


 @bottom {
        content: counter(page)
    }

}


.pageNumber::before {
  counter-increment: subsection;
  content: counter(section) "." counter(subsection) " ";
}

caption{
display:none;}


.pageNumber:after{

counter-increment: page;
content:"Page " counter(page);
text-align: center;
}

@page:first { counter-reset: page 9 }




   table { page-break-inside:auto;font-family:iransans !important }
   tr    { page-break-inside:avoid; page-break-after:auto }

.customizeTd{
  width:110px;
}

  .pageNumber{
    position: absolute;
    page-break-before: always;
    page-break-after: always;
    bottom: 0;
    right: 0;


}

  .pageNumber::before {
    position: relative;
    bottom: -20px;
    counter-increment: section;
    content: counter(section);
  }

  .filterImage{

display:none !important;
visibility:hidden !important;

}

@media print(){


.filterImage{

display:none !important;
visibility:hidden !important;

}

#pageNumber { content: counter(page) }




.customizeTd{
  width:110px;
  text-align:center;
}

*{
  direction: rtl !important;
  outline: none !important;
  font-family:"IRANSANsWeb"
  direction: rtl !important;
  outline: none !important;}


@font-face {
  font-family: "iransans";
  font-style: normal !important;
  src: url("/test/src/font/IRANSansWeb.eot");
  src: url("/test/src/font/IRANSansWeb.woff") format("woff"), url("/test/src/font/IRANSansWeb.ttf") format("truetype")
}

.printTable {
   font-family:iransans;
    width: 100%;
   margin-top: 5px;
   margin-bottom: 5px;
  border-collapse: collapse;
  direction: rtl !important;
  outline: none !important;
}

}

.printTable {
    font-family:iransans;
     width: 100%;
      margin-top: 15px;
      margin-bottom: 15px;
        border-collapse: collapse;
          direction: rtl !important;
  outline: none !important;

}

.panelRow {
  display: none;
}
.resid td {
  text-align: center !important;
}

.printTable td {
  border: 1px solid #636363;
  font-size: 0.7em;
  padding: 3px;
  text-align:center !important;
}


.captionTable span{
  margin: 10px;
}

.captionTable{

margin-bottom:15px;
}

.printTable th {
  text-align: center;
  border: 1px solid #636363;
  font-size: 0.7em;
  padding: 3px;
}



  .printPart {
    width: 100%;
    height:100%;
    position:relative;
    top:0px;
    bottom:0px;
    margin: auto;
font-family:"iransans"
  direction: rtl !important;

    /*border: 1px solid;*/
  }

  .printSection {
    display: table-cell;
      direction: rtl !important;
  outline: none !important;
  }

  .printPart {
    height:100%;
    /*border: 1px solid;*/
      direction: rtl !important;
  outline: none !important;
  }


'
                  trigger={() => (
                    <button disabled={this.state.buttonClicked ? false : true} className="printButton">
                      <i className="fas fa-print" />
                    </button>
                  )}
                  content={() => this.printTable}
                />
              </div>
            </div>
            <div className="basketFilterComponent">
              <div className="filterInputs">
                <FromToPicker
                  onChangeFromDate={this.handleChangeFromDate}
                  onChangeToDate={this.handleChangeToDate}
                  fromLabel="تاریخ از"
                  toLabel="تاریخ تا"
                  defaulValue={true}
                  fromId="from"
                  toId="to"
                />

                <div className="formComponent">
                  <AutoComplete
                    label="تامین کننده"
                    api={`${REPORT_RETAIL.REPORT_RETAIL_LIST_PROVIDER}`}
                    textField="title"
                    valueField="providerId"
                    id="provider"
                    value={this.state.providerId}
                    setValue={(providerId) => this.setState({providerId})}
                  />
                  {/* <label>تامین کننده:</label>
                                    <select className='form-control' onChange={this.changeSelectProvider.bind(this)} id='providerId'>
                                        <option value=''>-----</option>
                                        {this.state.providers.map((pro,index)=>(
                                            <option value={pro.providerId}
                                                    defaultValue={2093}
                                                    selected={pro.providerId=='2093'?true:false}
                                            >{pro.providerId+' - '+' '+pro.title}</option>
                                        ))}
                                    </select> */}
                </div>

                <div className="formComponent">
                  <SearchableCombo
                    options={this.state.Drivers}
                    getValueCombo={this.getValueDriver}
                    lableText="رساننده"
                    placeholder="------"
                    isClearable={true}
                    isMulti={false}
                    isDisabled={false}
                  />
                </div>
                <div className="formComponent">
                  <label>شیفت زمانی :</label>
                  <select className="form-control" id="planTimeType" onChange={this.changeShift.bind(this)}>
                    <option value="">-------</option>
                    {this.state.timesInterval.map((shift, index) => (
                      <option value={shift.timeIntervalId}>{shift.timeStart + ' تا ' + shift.timeEnd}</option>
                    ))}
                  </select>
                </div>
              </div>
              <div className="filterOption">
                <button className="confirmFilter" onClick={this.filter.bind(this)}>
                  جست و جو
                </button>
              </div>
            </div>
            <div className="showBaseTable print">
              <table className="baseTable printTable" ref={(node) => (this.printTable = node)}>
                <caption className="captionTable" style={{textAlign: 'center'}}>
                  <span> از : {this.state.fromPrintDate}</span>-<span> تا : {this.state.toPrintDate}</span>-
                  <span> تامین کننده : {this.state.providerText}</span>-
                  <span> رساننده : {this.state.finalShiftText}</span>
                  <br />
                  <span> بازه زمانی : {this.state.finalDriverText}</span>
                  {/*<span> بازه زمانی : {this.state.finalShiftText}</span>*/}
                </caption>
                <thead>
                  <tr style={{backgroundColor: '#f1f1f1'}}>
                    <td rowSpan={2}>از {this.state.fromPrintDate}</td>
                    <td rowSpan={2}>تا {this.state.toPrintDate}</td>
                    <td rowSpan={2}>تامین کننده {this.state.providerText}</td>
                    <td rowSpan={2}>رساننده {this.state.finalShiftText}</td>
                    <td rowSpan={2}>بازه زمانی {this.state.finalDriverText}</td>
                  </tr>
                </thead>
                <tbody>
                  <tr className="firstRow">
                    <td rowSpan={2}>ردیف</td>
                    <td rowSpan={2}>تاریخ تحویل</td>
                    <td rowSpan={2}>بازه تحویل</td>
                    {/*<td rowSpan={2}>شناسه فاکتور</td>*/}
                    <td
                      className={'customizeTd'}
                      rowSpan={2}
                      style={{fontSize: '1.2em', fontWeight: 600}}
                      onClick={() => this.sortBy('invoiceNum')}
                    >
                      شماره فاکتور{' '}
                      <span>
                        <img className="filterImage" src={require('../../image/filterTable.svg')} />{' '}
                      </span>
                    </td>
                    <td rowSpan={2}>نام خریدار</td>
                    <td rowSpan={2}>نام رساننده</td>
                    <td rowSpan={2} className="priceCell" onClick={() => this.sortBy('payment')}>
                      قابل پرداخت{' '}
                      <span>
                        <img className="filterImage" src={require('../../image/filterTable.svg')} />{' '}
                      </span>
                    </td>
                    {tilfValue}
                  </tr>
                  <tr>{tilfValue2}</tr>

                  {this.state.basket.map((items, index) => (
                    <tr key={index} style={index % 2 == 0 ? {backgroundColor: '#fff'} : {backgroundColor: '#f1f1f1'}}>
                      <td>{(pageNumber - 1) * dropDownVal + index + 1}</td>
                      <td>{jMoment(items.planDate).format('jYYYY/jM/jD')}</td>
                      <td>{items.planTimeFrom.substr(0, 5) + ' - ' + items.planTimeTo.substr(0, 5)}</td>
                      <td className={'customizeTd'} style={{fontSize: '1.2em'}}>
                        {items.invoice.invoiceNum}
                      </td>
                      <td>{items.invoice.buyerName}</td>
                      <td>{items.driver == null ? '' : items.driver.name}</td>
                      <td className="priceCell">{accounting.formatMoney(items.totalInfo.payableAmount, '', ',')}</td>
                      {/*{tilfKey}*/}
                      {this.state.ids.map((id, index, temp) => (
                        <React.Fragment>
                          <td>{this.showCount(id, items.items)}</td>
                          <td>{''}</td>
                        </React.Fragment>
                      ))}
                    </tr>
                  ))}
                  <tr>
                    <td colSpan={6}>مجموع</td>
                    <td colSpan={1} className="priceCell">
                      {accounting.formatMoney(sumpayable, '', ',')}
                    </td>
                    {this.state.sumCount.map((id, index) => (
                      <React.Fragment>
                        <td>{this.showSumCount(index)}</td>
                        <td>{''}</td>
                      </React.Fragment>
                    ))}
                  </tr>
                </tbody>
              </table>
              <span className="pageNumber" />
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default Animale
